<template>
  <DownloadModelsTable
    title="Download Reaction Generation Models"
    category-filter="Reaction Generation"
  />
</template>

<script>
import DownloadModelsTable from '@/components/DownloadModelsTable.vue';

export default {
  name: 'ReactionGenerationDownloadView',
  components: {
    DownloadModelsTable
  },
  mounted() {
    this.checkLoggedIn(this.$session);
  }
};
</script>
